import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { ToastsManager } from 'ng2-toastr/ng2-toastr';

import { TranslateService } from '@ngx-translate/core';
import { CookieManagerService } from './cookie-manager.service';
import { environment } from '../../';
import { CookieNames, ErrorCodes, AlertMessages, ErrorText, SuccessText, BasicRoutes, Regex ,FileTypes} from '../../core-modules/constant';
import { Error, User, NewUser } from '../../core-modules/model';

@Injectable()
export class ErrorManagerService {
  public regexp: RegExp = new RegExp(Regex.email);
  public error: Array<any> = [];

  constructor(
    public router: Router,
    public toastr: ToastsManager,
    public translateService: TranslateService,
    public cookieManagerService: CookieManagerService,
    ) { }

  commonError(err: any) {
    if (err) {
      switch (err.code) {
        case 4019:
          this.internetErrorPage(err.code || err.status);
          break;
        case 4010:
          this.internetErrorPage(err.code || err.status);
          break;
        default:
          err.code ?
            this.showError(ErrorText[err.code]) : '';
            // this.router.navigate([BasicRoutes.clientIntError]);
            break;
      }
    }
  }

  loginError(err: any) {
    if (err && err.code) {
      this.showError(ErrorText[err.code]);
    } else {
      this.showError('BROWSER_ERROR');
    }

  }

  loginFieldValidator(fields: User) {
    let isError: boolean;
    this.error = [];
    if (this.regexp.test(fields.email)) {
      this.error.push({ class: '', message: '', isError: false });
    } else {
      this.error.push({ class: 'has-error', message: 'EMAIL_FORMAT_ERROR', isError: true });
    }

    if (fields.password === undefined || fields.password.length < 6) {
      this.error.push({ class: 'has-error', message: 'PASSWORD_FORMAT_ERROR', isError: true });
    } else {
      this.error.push({ class: '', message: '', isError: false });
    }
    if (this.error[0].isError) {
      this.error.push(true);
    } else {
      this.error.push(false);
    }
    return this.error;
  }

  registerFieldValidator(fields: NewUser) {
    let isError: boolean;
    this.error = [];
    if (this.regexp.test(fields.email)) {
      this.error.push({ class: '', message: '', isError: false });
    } else {
      this.error.push({ class: 'has-error', message: 'EMAIL_FORMAT_ERROR', isError: true });
    }

    if (fields.password === undefined || fields.password.length < 6) {
      this.error.push({ class: 'has-error', message: 'PASSWORD_FORMAT_ERROR', isError: true });
    } else {
      this.error.push({ class: '', message: '', isError: false });
    }
    if (this.error[0].isError || this.error[1].isError) {
      this.error.push(true);
    } else {
      this.error.push(false);
    }
    return this.error;
  }

  commonSuccess(success: any) {
    if (success) {
      this.showSuccess(SuccessText[success.code]);
    } else {
      this.router.navigate([BasicRoutes.login]);
    }
  }



  internetErrorPage(error) {
    sessionStorage.clear();
    this.cookieManagerService.removeCookie(CookieNames.loginKey);
    this.cookieManagerService.deleteAll();
    this.router.navigate([BasicRoutes.login]);
  }



  /**
   * Error handeler
   */
  setError(err: any) {
    if (err.status === 401) {
      sessionStorage.clear();
      this.cookieManagerService.deleteAll();
      this.cookieManagerService.removeCookie(CookieNames.loginKey);
      this.cookieManagerService.deleteAll();
      this.router.navigate([BasicRoutes.login]);
      return;
    }
    let error = err.json();

    if(error && error.code){
       this.showError(ErrorText[error.code]);
    }else{
      // this.router.navigate([BasicRoutes.clientIntError]); 
    }
  }

  showSuccess(message: string) {
    this.toastr.success(this.translateService.instant(message), AlertMessages.success);
  }

  showError(message: string) {
    this.toastr.error(this.translateService.instant(message), AlertMessages.error, 6000);
  }

  showWarning(message: string) {
    this.toastr.warning(this.translateService.instant(message), AlertMessages.error);
  }

  immageFormatError(format:any){
    if (FileTypes.indexOf(format)!== -1) {
      return true;
    }else{
      return false;
    }
  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/shared/services/error-manager.service.ts